var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('loading'),_c('notification-snack'),(!_vm.isLoggedInSection)?_c('v-main',[_c('router-view')],1):_c('patient-portal-layout'),(_vm.isPatientPortalSection)?_c('portal-footer',{attrs:{"dark":true}}):_vm._e(),(_vm.isLoggedInSection)?_c('token-handler'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }